export default {
  STARTED: 'started',
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILURE: 'failure',
};
